import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { onWebsocketMessageDispatchUpdateEntities } from '@zerops/zef/entities';
import { UserEntity } from '@zerops/zerops/core/user-base';
import { ClientBalanceEntity } from './client-balance.entity';

// The list is subscribed by the page that shows it, the history is too long to keep for every client switch.
@Injectable()
export class ClientBalanceBaseEffect {

  private _setupUpdateStreamSubscription$ = createEffect(() => this._userEntity.activeClientId$.pipe(
    map((clientId) => this._clientBalanceEntity.updateSubscribe(clientId)
  )));

  private _onUpdateStreamMessage$ = createEffect(() => this._actions$.pipe(
    onWebsocketMessageDispatchUpdateEntities(this._clientBalanceEntity)
  ));

  constructor(
    private _actions$: Actions,
    private _clientBalanceEntity: ClientBalanceEntity,
    private _userEntity: UserEntity
  ) {}
}
